import { render, staticRenderFns } from "./ProfileWhoMarkedMeFavoriteUsers.vue?vue&type=template&id=03d23d95&scoped=true&"
import script from "./ProfileWhoMarkedMeFavoriteUsers.vue?vue&type=script&lang=js&"
export * from "./ProfileWhoMarkedMeFavoriteUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d23d95",
  null
  
)

export default component.exports